module.exports = __webpack_public_path__ + "static/img/huishengtoujiao.e41231d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huishengtoujiao.png
// module id = 5O4L
// module chunks = 1